import type React from 'react';
import { useState } from 'react';

import { IconSettings } from 'src/components/icons/icons-sidebar/icon-settings';
import { useGetPlatformsData } from 'src/hooks/data/platforms';
import { AvailableBrandsModal } from './available-brands-modal/available-brands-modal';

export const AvailableBrands: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data } = useGetPlatformsData({ withInactive: true });
  const hasNewBrands = data?.some((platform) => platform.brands.some((brand) => brand.isNew)) || false;

  return (
    <>
      <div
        className="group fixed bottom-0 left-0 w-[216px] h-[46px] border-t border-gray-5 flex items-center gap-x-12 pl-28 cursor-pointer"
        onClick={() => setIsModalOpen(true)}
      >
        <div className="relative">
          <IconSettings className="group-hover:opacity-100 ease duration-100 opacity-70" />
          {hasNewBrands && (
            <div className="absolute -top-4 -right-4 size-12 rounded-full bg-primary border border-gray-1" />
          )}
        </div>

        <div className="text-[14px]/[22px] group-hover:opacity-100 ease duration-100 opacity-70">Available Brands</div>
      </div>

      <AvailableBrandsModal isOpen={isModalOpen} close={() => setIsModalOpen(false)} />
    </>
  );
};
